const CardClass = Object.freeze({
	Base: 'm-card',
	Removeable: 'm-card--removeable',
});

export { CardClass };
